<script setup lang="ts">
defineProps({
	isShow: {
		type: Boolean,
		default: false,
		required: true,
	},
});

defineEmits<{
	(e: 'onClose'): void;
	(e: 'onConfirm'): void;
}>();
</script>

<template>
	<ConfirmDialog
		:is-show="isShow"
		confirm-button-name="Ok, I got it"
		hide-cancel-button
		@on-close="$emit('onClose')"
		@on-confirm="$emit('onConfirm')"
	>
		<template #header>
			<AlertCircleIcon
				class="icon-header-confirm-dlg icon-info"
				:color="ICON_COLOR.PRIMARY"
			/>
		</template>
		<template #title>
			Open Peatix in a supported browser
		</template>
		<template #content>
			<p class="text-sm text-regular">
				Your browser does not support social media sign-in. Please switch to a supported browser,
				such as Chrome or Safari, or use our “Continue with email” option.
			</p>
		</template>
	</ConfirmDialog>
</template>
